export enum ParametersEnum {
  doorType = 'doorType',
  colour = 'colour',
  forWetRooms = 'forWetRooms',
}

export enum DoorType {
  GLASS = 'GLASS',
  BLANK = 'BLANK',
  GLAZED = 'GLAZED',
}

export enum ForWetRoomsType {
  YES = 'true',
  NO = 'false',
}

export enum ColourType {
  WHITE = 'WHITE',
  BEIGE = 'BEIGE',
  SILVER = 'SILVER',
  BROWN = 'BROWN',
  BLACK = 'BLACK',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN',
}

export type Inputs = {
  doorType: Array<DoorType> | null;
  colour: Array<ColourType> | null;
  forWetRooms: ForWetRoomsType | null;
};

export type TGetIcon = {
  isSmall: boolean;
};
